module.exports = __webpack_public_path__ + "images/fa-track-exams-lms.jpg";